export default __webpack_public_path__ + "static/media/6.b9cb28ab.jpg";